import { Injectable } from '@angular/core';
import {Headers, Http} from '@angular/http';
import {ConnectionService} from './connection.service';
import {AppConfig} from '../app.config';
import {Observable} from 'rxjs/Observable';
import {ItemUsage} from '../entities/ItemUsage';

@Injectable()
export class ItemUsageService {

  params: string;
  feedback: string;
  apiUrl: string;

  get headers() : Headers {
    return this.connectionService.GetAuthorizationHeader();
  }

  constructor(private http: Http, private connectionService: ConnectionService, private config : AppConfig) {
    this.apiUrl = config.getConfig('endPointApiUrl') + 'api/ItemUsage/';
  }

  Create(itemUsage: ItemUsage): Observable<any> {
    this.params = JSON.stringify(itemUsage);

    return this.http.post(this.apiUrl + 'Create', this.params, {headers: this.headers});
  }

  CreateMultiple(itemUsages: ItemUsage[]): Observable<any> {
    this.params = JSON.stringify(itemUsages);

    return this.http.post(this.apiUrl + 'CreateMultiple', this.params, {headers: this.headers});
  }

  GetAll(): Observable<ItemUsage[]> {
    return this.http
      .get(this.apiUrl, {headers: this.headers})
      .map(response => response.json() as ItemUsage[]);
  }

  GetFromTask(taskGuid : string): Observable<ItemUsage[]> {
    return this.http
      .get(this.apiUrl + "GetFromTask/" + taskGuid, {headers: this.headers})
      .map(response => response.json() as ItemUsage[]);
  }


  Get(id: number): Observable<ItemUsage> {
    return this.http
      .get(this.apiUrl + '' + id, {headers: this.headers})
      .map(response => response.json() as ItemUsage);
  }

  Put(item: ItemUsage) : Observable<any>{
    this.params = JSON.stringify(item);
    return this.http.put(this.apiUrl + 'Update/',
      this.params, {headers: this.headers});
  }

  Delete(no: number) : Observable<any> {
    return this.http.delete(this.apiUrl + 'Delete/' + no, {headers: this.headers});
  }

}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/item-usage.service.ts